// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CustomSelect {
  position: relative;
  display: flex;
  flex-direction: column;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 100%;
}
.CustomSelect__label {
  font-family: "Outfit";
  font-style: normal;
  font-weight: 300;
  font-size: 1.4rem;
  line-height: 1.8rem;
}
.CustomSelect__small__icon {
  font-weight: 500;
}
.CustomSelect__button {
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  width: 100%;
  height: 56px;
  padding: 1.125rem 1rem;
  margin: 8px 0;
  border-radius: 12px;
  text-align: left;
  line-height: 1.5;
  background: #fff;
  border: 1px solid #d0d7de;
  color: #8c8c8c;
  transition: all 120ms cubic-bezier(0.4, 0, 0.2, 1);
  font-size: 1.6rem;
  color: #333333;
  font-family: Outfit;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0em;
}
.CustomSelect__button:hover {
  background: #f6f8fa;
  border-color: #afb8c1;
}
.CustomSelect__button.open::after {
  color: #000000;
}
.CustomSelect__button::after {
  float: right;
}
.CustomSelect__options {
  position: absolute;
  z-index: 99;
  top: 75px;
  left: 0;
  width: 100%;
  overflow-y: auto;
  font-size: 0.875rem;
  box-sizing: border-box;
  padding: 6px;
  border-radius: 12px;
  outline: 0px;
  background: #fff;
  border: 1px solid #d0d7de;
  color: #24292f;
}
.CustomSelect__option {
  width: 100%;
  padding: 18px 16px;
  gap: 10px;
  font-family: "Outfit";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  color: #333333;
  width: 100%;
  height: 56px;
  list-style: none;
  padding: 8px;
  border-radius: 8px;
  cursor: default;
}
.CustomSelect__option:hover {
  background-color: rgb(238, 238, 238);
  color: #24292f;
}
.CustomSelect__validation {
  display: flex;
  justify-content: flex-start;
  position: relative;
}
.CustomSelect__validation__message {
  display: flex;
  position: absolute;
  top: -12px;
  justify-content: center;
  align-items: center;
  font-family: "Outfit";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
}
.CustomSelect__validation__icon {
  position: absolute;
  top: -10px;
  width: 1.1rem;
  height: 1.1rem;
  margin-right: 0.25rem;
}`, "",{"version":3,"sources":["webpack://./src/Components/Common/CustomSelect/CustomSelect.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,aAAA;EACA,sBAAA;EAEA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,WAAA;AAAJ;AACI;EACI,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AACR;AAEI;EAEI,gBAAA;AADR;AAGI;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,cAAA;EACA,kDAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AADR;AAEQ;EACI,mBAAA;EACA,qBAAA;AAAZ;AAIY;EACI,cAAA;AAFhB;AAMQ;EACI,YAAA;AAJZ;AAOI;EACI,kBAAA;EACA,WAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EAEA,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,YAAA;EAEA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,yBAAA;EACA,cAAA;AAPR;AAUI;EACI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AARR;AASQ;EACI,oCAAA;EACA,cAAA;AAPZ;AAUI;EACI,aAAA;EACA,2BAAA;EACA,kBAAA;AARR;AAUI;EACI,aAAA;EACA,kBAAA;EACA,UAAA;EACA,uBAAA;EACA,mBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AARR;AAWI;EACI,kBAAA;EACA,UAAA;EACA,aAAA;EACA,cAAA;EACA,qBAAA;AATR","sourcesContent":[".CustomSelect {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    // height: 100px;\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n    width: 100%;\n    &__label {\n        font-family: 'Outfit';\n        font-style: normal;\n        font-weight: 300;\n        font-size: 1.4rem;\n        line-height: 1.8rem;\n        // color: $Dark50;\n    }\n    &__small__icon {\n        // color: $red;\n        font-weight: 500;\n    }\n    &__button {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        box-sizing: border-box;\n        width: 100%;\n        height: 56px;\n        padding: 1.125rem 1rem;\n        margin: 8px 0;\n        border-radius: 12px;\n        text-align: left;\n        line-height: 1.5;\n        background: #fff;\n        border: 1px solid #d0d7de;\n        color: #8c8c8c;\n        transition: all 120ms cubic-bezier(0.4, 0, 0.2, 1);\n        font-size: 1.6rem;\n        color: #333333;\n        font-family: Outfit;\n        font-size: 16px;\n        font-weight: 400;\n        line-height: 20px;\n        letter-spacing: 0em;\n        &:hover {\n            background: #f6f8fa;\n            border-color: #afb8c1;\n        }\n\n        &.open {\n            &::after {\n                color: #000000;\n            }\n        }\n\n        &::after {\n            float: right;\n        }\n    }\n    &__options {\n        position: absolute;\n        z-index: 99;\n        top: 75px;\n        left: 0;\n        width: 100%;\n        // max-height: 98px;\n        overflow-y: auto;\n        font-size: 0.875rem;\n        box-sizing: border-box;\n        padding: 6px;\n        // margin: 12px 0px;\n        border-radius: 12px;\n        outline: 0px;\n        background: #fff;\n        border: 1px solid #d0d7de;\n        color: #24292f;\n        // box-shadow: 0px 4px 10px #d0d7de;\n    }\n    &__option {\n        width: 100%;\n        padding: 18px 16px;\n        gap: 10px;\n        font-family: 'Outfit';\n        font-style: normal;\n        font-weight: 400;\n        font-size: 16px;\n        line-height: 20px;\n        color: #333333;\n        width: 100%;\n        height: 56px;\n        list-style: none;\n        padding: 8px;\n        border-radius: 8px;\n        cursor: default;\n        &:hover {\n            background-color: rgb(238, 238, 238);\n            color: #24292f;\n        }\n    }\n    &__validation {\n        display: flex;\n        justify-content: flex-start;\n        position: relative;\n    }\n    &__validation__message {\n        display: flex;\n        position: absolute;\n        top: -12px;\n        justify-content: center;\n        align-items: center;\n        font-family: 'Outfit';\n        font-style: normal;\n        font-weight: 400;\n        font-size: 12px;\n        line-height: 15px;\n        // color: $red;\n    }\n    &__validation__icon {\n        position: absolute;\n        top: -10px;\n        width: 1.1rem;\n        height: 1.1rem;\n        margin-right: 0.25rem;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
